import React, {
  FunctionComponent,
  useEffect,
  useState,
  useContext,
  Fragment,
} from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
  TextField,
  Typography,
} from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

type modalForm = {
  first: string;
  second: string;
  third: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
      minWidth: 345,
      width: 345,
    },
    header: {
      backgroundColor: '#1C6E7D',
    },
    address: {
      textAlign: 'center',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
      justifyContent: 'center',
    },
    divider: {
      width: '85%',
      margin: '8px auto',
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    formControl: {
      margin: theme.spacing(3),
      textAlign: 'left',
    },
    button: {
      margin: theme.spacing(1, 1, 0, 0),
    },
    buttons: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'space-around',
    },
  })
);

const Modal = (props: any) => {
  const classes = useStyles();
  const { register, handleSubmit, watch, errors, getValues, control } =
    useForm<modalForm>({
      defaultValues: {},
    });
  const [value, setValue] = useState('');
  const [text, setText] = useState('');
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
    setHelperText(' ');
    setError(false);
  };
  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setText((event.target as HTMLInputElement).value);
    setHelperText(' ');
    setError(false);
  };
  const onSubmitHandler = () => {
    if (value === '') {
      setHelperText('لطفا یک گزینه را انتخاب کنید');
      setError(true);
    } else if (value == 'other' && text == '') {
      setHelperText('توضیحات خالی است');
      setError(true);
    } else {
      if (value != '' && text != '') {
        props.updateStatusHandler(text, props.idCard);
      } else if (value != 'other' && text == '') {
        props.updateStatusHandler(value, props.idCard);
      }
    }
  };
  return (
    <Fragment>
      {props.modalType == 'NOT_DELIVERED' ? (
        <Dialog
          fullWidth
          open={props.openModal}
          onClose={props.closeModalHandler}
          aria-labelledby="responsive-dialog-title"
          style={{ textAlign: 'center' }}
        >
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <DialogTitle style={{ textAlign: 'left' }}>
              <IconButton
                aria-label="settings"
                onClick={props.closeModalHandler}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <FormControl
                component="fieldset"
                error={error}
                className={classes.formControl}
              >
                <FormLabel
                  component="legend"
                  style={{ color: 'black', margin: '0 0 30px 0' }}
                >
                  {'علت عدم تحویل سفارش را انتخاب کنید:'}
                </FormLabel>
                <RadioGroup
                  aria-label="quiz"
                  name="quiz"
                  value={value}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel
                    style={{ margin: '0 0 5px 0' }}
                    value="تحویل گیرنده در منزل حضور نداشت"
                    control={<Radio />}
                    label="تحویل گیرنده در منزل حضور نداشت"
                  />
                  <FormControlLabel
                    style={{ margin: '0 0 5px 0' }}
                    value="تحویل گیرنده بسته را تحویل نگرفت"
                    control={<Radio />}
                    label="تحویل گیرنده بسته را تحویل نگرفت"
                  />
                  <FormControlLabel
                    style={{ margin: '0 0 5px 0' }}
                    value="other"
                    control={<Radio />}
                    label="سایر(در توضیحات علت حتما ذکر شود)"
                  />
                </RadioGroup>
                <TextField
                  variant="outlined"
                  disabled={value != 'other'}
                  placeholder="توضیحات ..."
                  onChange={handleTextFieldChange}
                  fullWidth
                  style={{ marginTop: '10px' }}
                />
                <FormHelperText>{helperText}</FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogActions className={classes.buttons}>
              <Button color="primary" variant="contained" type="submit">
                {'تایید عدم تحویل سفارش'}
              </Button>
              <Button
                onClick={props.closeModalHandler}
                variant="outlined"
                color="primary"
              >
                {'انصراف'}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      ) : props.cod.codValue === false ? (

        <Dialog
          fullWidth
          open={props.openModal}
          onClose={props.closeModalHandler}
          aria-labelledby="responsive-dialog-title"
          style={{ textAlign: 'center' }}
        >
          <DialogTitle style={{ textAlign: 'left' }}>
            <IconButton aria-label="settings" onClick={props.closeModalHandler}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormControl
              component="fieldset"
              error={error}
              className={classes.formControl}
            >
              <FormLabel
                component="legend"
                style={{ color: 'black', margin: '0 0 30px 0' }}
              >{`آیا از تحویل سفارش شناسه ${props.idCard} اطمینان دارید؟`}</FormLabel>
            </FormControl>
          </DialogContent>
          <DialogActions className={classes.buttons}>
            <Button
              onClick={() => props.changeStatusOrder(props.idCard)}
              color="primary"
              variant="contained"
            >
              {'تایید تحویل سفارش'}
            </Button>
            <Button
              onClick={props.closeModalHandler}
              variant="outlined"
              color="primary"
            >
              {'انصراف'}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          fullWidth
          open={props.openModal}
          onClose={props.closeModalHandler}
          aria-labelledby="responsive-dialog-title"
          style={{ textAlign: 'center' }}
        >
          <DialogTitle style={{ textAlign: 'left' }}>
            <IconButton aria-label="settings" onClick={props.closeModalHandler}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container xs={12} spacing={4} style={{ marginBottom: '20px' }}>
              <Grid item xs={12}>
                <span>{'مبلغ (ریال) :'}</span>
                <span>{props.cod.codValue}</span>
              </Grid>
              <Grid item xs={12}>
                <span>{'شناسه پرداخت :'}</span>
                <span>{props.cod.codPaymentCode}</span>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.buttons}>
            <Button
              onClick={() => props.changeStatusOrder(props.idCard)}
              variant="contained"
              style={{ backgroundColor: '#1B68FF', color: 'white' }}
            >
              {'مبلغ را دریافت کردم'}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Fragment>
  );
};

export default Modal;
